// #region imports

// --- Angular
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';

// --- HS Code
import { environment } from '../../../../environments/environment';
import { Constants, SortDirections, SurveySummaryModel, TrackMyJourneyResultsModel } from '../../../models';
import { CompareReportBaseService } from './compare-report-base.service';
import { SurveyBaseService } from '../survey/survey-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class CompareReportService extends CompareReportBaseService {

  constructor(
    private httpClient: HttpClient,
    _surveyService: SurveyBaseService
  ) {
    super(_surveyService);
  }

  loadCampaigns(identifier: string): void {
    if (!identifier) {
      return;
    }

    this._surveyIdentifierForComparison$.next(identifier);
    this._surveyService.loadSummaries(Constants.MAXIMUM_NUMBER_OF_SELF_SURVEYS, 1, '', '', SortDirections.descending);

    // const url = environment.apiConfig.surveyApiUrl + environment.apiConfig.compareReportsApi + `?campaignId=${identifier}`;
    // this._campaignsLoading$.next(true);

    // this.httpClient.get<SurveySummaryModel[]>(url).pipe(
    //   retryBackoff(environment.retryConfig),
    //   catchError(this._getError.bind(this))
    // ).subscribe(results => {
    //   this._campaignsLoading$.next(false);
    //   this._campaigns$.next(results);
    // });
  }

  compareResults(primaryIdentifier: string, secondaryIdentifier: string): void {
    if (!primaryIdentifier || !secondaryIdentifier) {
      return;
    }

    const url = environment.apiConfig.surveyApiUrl + environment.apiConfig.compareReportsApi;
    const model = {
      primaryParticipantId: primaryIdentifier,
      secondaryParticipantId: secondaryIdentifier
    };

    this.httpClient.post<TrackMyJourneyResultsModel[]>(url, model).pipe(
      retryBackoff(environment.retryConfig),
      catchError(this._postError.bind(this))
    ).subscribe(results => {
      for (const tmjModel of results) {
        tmjModel.disabled = false;
        tmjModel.scoreList = this._mapScores(tmjModel.surveyResults);
      }
      this._areResultsLoading$.next(false);
      this._surveyResults$.next(results);
    });
  }

  private _getError(err: any): Observable<SurveySummaryModel[]> {
    return of([] as SurveySummaryModel[]);
  }

  private _postError(err: any): Observable<TrackMyJourneyResultsModel[]> {
    return of([] as TrackMyJourneyResultsModel[]);
  }
}
